export const ServerURL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ?
  'https://127.0.0.1:8000/' :
  '/';

export const getUrl = (path) => `${ServerURL}api/${path}`;
